import { useState } from "react";
import { Button, Flex, Heading, Text } from "@chakra-ui/react";

import { getPasskeyRegistrations, removePasskeyRegistration, PasskeyRegistration } from "../../services/passkey";

export default function PasskeyManageList({ pubkey }: { pubkey: string }) {
  const [regs, setRegs] = useState(() => getPasskeyRegistrations().filter((r) => r.pubkey === pubkey));

  if (regs.length === 0) return null;

  const handleRemove = (reg: PasskeyRegistration) => {
    removePasskeyRegistration(reg.credentialId);
    setRegs((prev) => prev.filter((r) => r.credentialId !== reg.credentialId));
  };

  return (
    <>
      <Heading size="md" mt="4">
        Passkeys
      </Heading>
      {regs.map((reg) => (
        <Flex key={reg.credentialId} align="center" gap="3" py="1">
          <Text fontWeight="medium">{reg.label}</Text>
          <Text fontSize="sm" color="gray.500">
            {new Date(reg.createdAt).toLocaleDateString()}
          </Text>
          <Button
            size="xs"
            colorScheme="red"
            variant="ghost"
            ms="auto"
            onClick={() => handleRemove(reg)}
          >
            Remove
          </Button>
        </Flex>
      ))}
    </>
  );
}
